(() => {
  const widget = document.querySelector('[data-pantera-whatsapp]');
  if (!widget) return;

  const trigger = widget.querySelector('[data-pantera-whatsapp-trigger]');
  const panel = widget.querySelector('#pantera-whatsapp-panel');
  const closeButton = widget.querySelector('[data-pantera-whatsapp-close]');

  if (!(trigger instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) {
    return;
  }

  const setOpen = (open, restoreFocus = false) => {
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));

    if (open) {
      closeButton?.focus();
    } else if (restoreFocus) {
      trigger.focus();
    }
  };

  trigger.addEventListener('click', () => {
    setOpen(panel.hidden);
  });

  closeButton?.addEventListener('click', () => {
    setOpen(false, true);
  });

  document.addEventListener('click', (event) => {
    if (!panel.hidden && event.target instanceof Node && !widget.contains(event.target)) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      setOpen(false, true);
    }
  });
})();
